import { initDevices } from "./init";
import { thunkSpreader } from "../../../utils/helpers";
import * as thunks from "./thunks";

const thunkEnum = thunkSpreader(thunks);
const { searchDevices } = thunks.devices;

export const extraReducers = {
  [initDevices.pending]: (state) => {
    state.init.status = "loading";
  },
  [initDevices.fulfilled]: (state, action) => {
    return {
      ...state,
      init: {
        status: "success",
      },
      ...action.payload,
    };
  },
  [initDevices.rejected]: (state) => {
    return {
      ...state,
      init: {
        status: "error",
      },
    };
  },
  ...thunkEnum,
  [searchDevices.pending]: (state) => {
    state.loading = true;
    state.error = null;
  },
  [searchDevices.fulfilled]: (state, action) => {
    return {
      ...state,
      ...action.payload,
      loading: false,
      error: null,
    };
  },
  [searchDevices.rejected]: (state, action) => {
    state.loading = false;
    state.error = action.payload || action.error?.message || "Failed to load trackers.";
  },
};
